import React from 'react';
import gfm from 'remark-gfm';
import ReactMarkdownWithHtml from 'react-markdown/with-html';
import './assets/css/markdown_content.css';

export default function MarkdownContent(props) {
  return (
    <div id='markdown-content' className={props.className}>
      <ReactMarkdownWithHtml plugins={[gfm]} children={props.content} />
    </div>
  );
}
